import React from 'react';

import Skeleton from 'react-loading-skeleton';
import { oneOf } from 'prop-types';

import WithSkeletonTheme from '../../WithSkeletonTheme';
import styles from './ProductInfoSkeleton.module.scss';

const PANEL_SECTIONS = [
  { key: 'core', fields: 4 },
  { key: 'seo', fields: 3 },
  { key: 'pricing', fields: 3 },
  { key: 'inventory', fields: 3 },
  { key: 'shipping', fields: 3 },
  { key: 'attributes', fields: 4 },
  { key: 'extra', fields: 4 },
];

const FIELD_ROWS = 4;

const FieldRow = () => (
  <div className={styles.field}>
    <Skeleton width={88} height={12} />
    <Skeleton height={32} borderRadius={4} />
  </div>
);

const ProductInfoSkeleton = ({ variant }) => {
  const isFields = variant === 'fields';

  return (
    <div
      className={isFields ? styles.fields : styles.panel}
      data-testid={isFields ? 'product-info-fields-skeleton' : 'product-info-skeleton'}
      data-qa={isFields ? 'product-info-fields-skeleton' : 'product-info-skeleton'}
    >
      <WithSkeletonTheme>
        <Choose>
          <When condition={isFields}>
            {Array.from({ length: FIELD_ROWS }, (_, index) => (
              <FieldRow key={index} />
            ))}
          </When>
          <Otherwise>
            {PANEL_SECTIONS.map((section) => (
              <div key={section.key} className={styles.section}>
                <Skeleton width={120} height={14} />
                {Array.from({ length: section.fields }, (_, index) => (
                  <FieldRow key={index} />
                ))}
              </div>
            ))}
          </Otherwise>
        </Choose>
      </WithSkeletonTheme>
    </div>
  );
};

ProductInfoSkeleton.propTypes = {
  variant: oneOf(['panel', 'fields']),
};

ProductInfoSkeleton.defaultProps = {
  variant: 'panel',
};

export default ProductInfoSkeleton;
